import styled from 'styled-components';
import logo from '~/assets/icons/logo.png';

const StyledOverlay = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.9);
	backdrop-filter: blur(20px);
`;

const StyledShadow = styled.div`
	position: absolute;
	left: 50%;
	top: calc(50% - 9.94px);
	transform: translate(-50%, -50%);
	width: 2770px;
	height: 1558px;
	opacity: 0.5;
	background: radial-gradient(
		50% 50% at 50% 50%,
		rgba(0, 0, 0, 0) 47.396%,
		#000000 100%
	);
	pointer-events: none;
`;

const StyledLogo = styled.img.attrs({ src: logo })`
	position: absolute;
	left: 50%;
	bottom: 60px;
	transform: translateX(-50%);
	width: 40px;
	height: 40px;
	opacity: 0.25;
	user-select: none;
	pointer-events: none;
`;

export { StyledLogo, StyledOverlay, StyledShadow };
